import {
  Mutation,
  TabaPayChallengeInitInput,
  TabaPayChallengeInitResult,
  TabaPayChallengeInitResultTypenames,
} from '@varo/graphql-schema-types';
import { checkError } from 'features/moveMoney/screens/dcf/tabapay/helpers/TabaPay.helpers';
import { useState } from 'react';
import TabaPayChallengeInit from 'services/graphql/mutations/MoveMoney/TabaPay/ChallengeInit';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useMutation } from 'urql';

export const useTabaPayChallengeInit = () => {
  const [{ data, error, fetching }, executeMutation] =
    useMutation<Mutation>(TabaPayChallengeInit);

  const { defaultTitle, defaultMessage } = useDefaultErrorStrings();
  const [errorScreen, setErrorScreen] = useState<{
    screenType: ErrorScreenType.Error;
    messageHeadline: string;
    messageBody: string;
  } | null>(null);

  const triggerChallengeInit = async (
    input: TabaPayChallengeInitInput,
  ): Promise<TabaPayChallengeInitResult> => {
    const result = await executeMutation({ input });
    if (!result.data) {
      throw new Error('No data returned from challenge init');
    }

    if (
      result.data.tabaPayChallengeInit.__typename ===
      TabaPayChallengeInitResultTypenames.TabaPayChallengeInitResultError
    ) {
      setErrorScreen({
        screenType: ErrorScreenType.Error,
        messageHeadline: result.data.tabaPayChallengeInit.title,
        messageBody: result.data.tabaPayChallengeInit.message,
      });
    }

    if (error) {
      const errorObject = checkError(error, defaultTitle, defaultMessage);
      setErrorScreen({
        screenType: ErrorScreenType.Error,
        ...errorObject,
      });
    }
    return result.data.tabaPayChallengeInit;
  };

  return {
    triggerChallengeInit,
    triggerChallengeInitResult: {
      errorScreen,
      data: data?.tabaPayChallengeInit,
      fetching,
      error,
    },
  };
};
